import { render } from "./App.vue?vue&type=template&id=89b7177e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=89b7177e&lang=css"
script.render = render

export default script